// authRedirect.js
// ==========================================
// دالة موحدة لتحديد "صفحة الهبوط" بعد تسجيل الدخول أو التحقق من OTP
// الأولوية دايمًا لـ allowedPage (تقييد خاص اتحدد من صفحة "المستخدمين")
// لو مفيش تقييد خاص، بنرجع لمنطق الدور الوظيفي العادي
// ==========================================

const ADMIN_ROLE_ID = 1;
const ADMIN_DEFAULT_PAGE = "/dashboard";
const USER_DEFAULT_PAGE = "/SupportdSec1";

export const getLandingPage = (user) => {
  if (!user) return "/";

  // 1. لو المستخدم معاه allowedPage محددة، ده أهم حاجة ولازم يروح عليها هي بس
  if (user.allowedPage) {
    return user.allowedPage;
  }

  // 2. مفيش تقييد خاص -> اعتمد على الدور الوظيفي
  const isAdmin = Number(user.roleId) === ADMIN_ROLE_ID;
  return isAdmin ? ADMIN_DEFAULT_PAGE : USER_DEFAULT_PAGE;
};

export default getLandingPage;
